export class ForeignKeyCellRenderer {
  init(params) {
    this.params = params;
    this.eGui = document.createElement('span');
    this.eGui.classList.add('custom-fk-renderer');
    this.updateDisplay();
  }

  getGui() {
    return this.eGui;
  }

  updateDisplay() {
    const params = this.params;
    const fkColId = params.colDef.colId;
    const displayNameColName = `${fkColId}_name_ref`;
    let preFetchedDisplayName = '';
    let keys = '';

    // Part 1: the referenced business key, supplied by the server as one
    // `<col>_<pkName>_ref` field per key column. Nothing is parsed out of the cell
    // value, which is now just the referenced record's trdm_record_id.
    const pkColumnNames =
      (params.colDef.cellRendererParams && params.colDef.cellRendererParams.pkColumnNames) || [];
    if (params.data) {
      const keyParts = pkColumnNames
        .map(pkName => params.data[`${fkColId}_${pkName}_ref`])
        .filter(val => val !== null && val !== undefined && String(val).trim() !== '')
        .map(val => String(val));
      if (keyParts.length > 0) {
        keys = keyParts.join(' _ ');
      }
    }

    // Part 2: Pre-fetched display name
    if (params.data && params.data.hasOwnProperty(displayNameColName)) {
      const fetchedName = params.data[displayNameColName];
      if (fetchedName !== null && fetchedName !== undefined && String(fetchedName).trim() !== '') {
        preFetchedDisplayName = String(fetchedName);
      }
    } else {
      if (params.value) {
          console.warn(`ForeignKeyCellRenderer: Pre-fetched display name '${displayNameColName}' not found in params.data for ${fkColId}.`);
      }
    }

    // Part 3: Build final display text
    // pkIsLookupColumn = true means no separate PK; the lookup display column IS the key.
    // In that case, suppress the (PK) suffix entirely — just show the display name.
    const pkIsLookupColumn = !!(params.colDef.cellRendererParams && params.colDef.cellRendererParams.pkIsLookupColumn);

    if (pkIsLookupColumn) {
      // No separate PK: show just the display name
      this.eGui.textContent = preFetchedDisplayName || keys || '';
    } else if (preFetchedDisplayName && keys) {
      // Has PK: "DisplayName (PK)"
      this.eGui.textContent = `${preFetchedDisplayName} (${keys})`;
    } else if (preFetchedDisplayName) {
      this.eGui.textContent = preFetchedDisplayName;
    } else if (keys) {
      this.eGui.textContent = `(${keys})`;
    } else {
      this.eGui.textContent = '';
    }
  }

  refresh(params) {
    this.params = params;
    this.updateDisplay();
    return true; // Indicates the component has refreshed successfully
  }

  destroy() {
    // Perform any cleanup, e.g., remove event listeners if any were added directly
  }
}
